import { IconButton, IconButtonProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { BackIcon } from 'src/components/icons';
import { BlackHeadings, NonHoverBorder } from 'src/theme/colors';

import { Flex } from '../Containers';

const useStyles = makeStyles()((theme) => ({
  root: {
    gap: theme.spacing(2),
    color: BlackHeadings,
  },
  buttonIcon: {
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${NonHoverBorder}`,
    padding: theme.spacing(1),
    '& svg': {
      fontSize: 12,
    },
  },
}));

export const BackButton: React.FC<IconButtonProps> = ({
  children,
  ...props
}) => {
  const { classes } = useStyles();

  return (
    <Flex className={classes.root}>
      <IconButton className={classes.buttonIcon} {...props}>
        <BackIcon />
      </IconButton>
      {children}
    </Flex>
  );
};
